import { createAction } from 'redux-actions';

export const openTransactionParticipantDrawerAction = createAction(
  'DRAWERS/OPEN_TRANSACTION_PARTICIPANT_DRAWER',
);
